enum EventTypeEnum {
  online = 'blue',
  mix = 'yellow',
  onsite = 'fucsia'
}

export default EventTypeEnum;